/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { getEngineeringAuditEscalationFactor } from 'plugin-codaf-risk-ext-bowtie/services/engineeringAudit'
import {
    IEngineeringAuditEscalationFactorReport,
    ISelectBowtie
} from 'plugin-codaf-risk-ext-bowtie/types/engineeringAudit'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { NoData, NoInfo } from '../../styles'

interface IProps {
    setItemsLength: (k: number) => void
    numberOfItems: number
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    filterByResource: string
    filterByBowtie: ISelectBowtie
    limit: number
    searchString: string
}

interface IOrder {
    field: string
    order: boolean
}

export const EngineeringAuditEscalationFactorReport: React.FC<IProps> = ({
    setPage,
    setItemsLength,
    numberOfItems,
    startDay,
    startHour,
    endDay,
    endHour,
    page,
    filterByBowtie,
    filterByResource,
    limit,
    searchString
}) => {
    const [events, setEvents] = useState<IEngineeringAuditEscalationFactorReport>()
    const [isLoading, setIsLoading] = useState(false)

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const formatedDate = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${formatedDate}`
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reports) {
            const renderObject = events?.reports.map((item, index) => {
                return (
                    <tr key={index} className={index === 0 && 'first-margin'}>
                        <td valign="middle">{dateConverter(item.date)}</td>
                        <td valign="middle">{item.escalationFactorName}</td>
                        <td valign="middle">{item.escalationFactorId}</td>
                        <td valign="middle">{item.contribution ?? ''}</td>
                        <td valign="middle">{item.fatherBarrierName}</td>
                        <td valign="middle">{item.fatherBarrierId}</td>
                        <td valign="middle">{item.responsiblePerson}</td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const engineeringAuditEvents = await getEngineeringAuditEscalationFactor(filterByBowtie.value, {
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: [filterByResource],
                filterByBowtieName: [filterByBowtie?.label],
                limit: limit.toString(),
                quickSearch: searchString
            })
            setEvents(engineeringAuditEvents)
            setItemsLength(engineeringAuditEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const handleOrder = (field: string): void => {
        if (field === order.field) {
            setOrder({ field: order.field, order: !order.order })
        } else {
            setOrder({ field: field, order: true })
        }
    }

    useEffect(() => {
        getEvents()
    }, [startDay, startHour, endDay, endHour, page, order, limit, searchString])
    useEffect(() => {
        setPage(1)
    }, [order])

    return (
        <div className="tableContainer">
            <table>
                <thead>
                    <tr>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.DATE)}>
                                {i18n('date/time')}{' '}
                                {order.field === OrderFields.DATE ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.ESCALATION_FACTOR_NAME)}>
                                {i18n('escalation factor')}{' '}
                                {order.field === OrderFields.ESCALATION_FACTOR_NAME ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.ESCALATION_FACTOR_ID)}>
                                {i18n('id (escalation factor)')}{' '}
                                {order.field === OrderFields.ESCALATION_FACTOR_ID ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.CONTRIBUITION)}>
                                {i18n('contribution')}{' '}
                                {order.field === OrderFields.CONTRIBUITION ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.FATHER_BARRIER_NAME)}>
                                {i18n('principal barrier')}{' '}
                                {order.field === OrderFields.FATHER_BARRIER_NAME ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.FATHER_BARRIER_ID)}>
                                {i18n('id (principal barrier)')}{' '}
                                {order.field === OrderFields.FATHER_BARRIER_ID ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                        <th>
                            <Button onClick={() => handleOrder(OrderFields.RESPONSIBLE_PERSON)}>
                                {i18n('responsible')}{' '}
                                {order.field === OrderFields.RESPONSIBLE_PERSON ? (
                                    order.order ? (
                                        <i className="far fa-arrow-up"></i>
                                    ) : (
                                        <i className="far fa-arrow-down"></i>
                                    )
                                ) : (
                                    ''
                                )}
                            </Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <NoInfo>
                            <i className="fa fa-spinner fa-spin" />
                        </NoInfo>
                    ) : events?.total === 0 ? (
                        <NoData>{i18n('There is no data for the specified period.')}</NoData>
                    ) : (
                        renderTableRow()
                    )}
                </tbody>
            </table>
        </div>
    )
}
